module.exports = __webpack_public_path__ + "img/dance-work-icon3.76aa602b.png";